import React from 'react'

import { formatCurrency } from 'utils/formatters'
import { padLeft } from 'utils'

import Button from 'common/Button'
import Card from 'common/Card'
import ReactTable from 'common/ReactTable' 

export default ({ resource, siItem, caseCurrency }) => {
  const { documentIndex, lines, totalExclVat, totalInclVat, attachmentId } = siItem

  const columns = React.useMemo(
    () => [
      {
        Header: `${resource.PO} #`,
        accessor: 'poLineIndex',
        headerClassName: 'col',
        className: 'col',
        Cell: ({ value, row }) => (
          <span title={value} className="word-break-break-word white-space-normal">
            {padLeft(value, 1)}
          </span>
        ),
      },
      {
        Header: resource.Description,
        accessor: 'description',
        headerClassName: 'col',
        className: 'col',
        footerClassName: 'col text-end fw-bold',
        Cell: ({ value, row }) => (
          <span title={value} className="word-break-break-word white-space-normal">
            {value}
          </span>
        ),
        Footer: () => (
          <div>
            <div className="p-1">{`${resource.TotalExclVat}:`}</div>
            <div className="p-1">{`${resource.TotalInclVat}:`}</div>
          </div>
        ),
      },
      {
        Header: resource.SiAmount,
        accessor: 'subTotal.value',
        headerClassName: 'col-2 text-end',
        className: 'col-2 border-left text-end border-start',
        footerClassName: 'col-2 border-left text-end fw-bold border-start',
        Cell: ({ value, row }) => <span>{value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'}</span>,
        Footer: () => (
          <div>
            <div className="p-1">{formatCurrency(totalExclVat.value, undefined, caseCurrency.currencySymbol)}</div>
            <div className="p-1">{formatCurrency(totalInclVat.value, undefined, caseCurrency.currencySymbol)}</div>
          </div>
        ),
      },
    ],
    [resource]
  )

  const fileLink = `${process.env.REACT_APP_API_URL}/file/${attachmentId}`

  return (
     <div className="d-flex flex-column flex-lg-row gap-3 align-items-start">
    <Card
      outline
      title={
        <div className="mb-lg-0 mb-1 white-space-break-spaces text-lg-start text-center">
          <strong>{resource.SalesInvoice}</strong> {`#${padLeft(documentIndex, 1)}`}
        </div>
      }
      className="position-relative margin-bot-20"
      titleClassName="white-space-nowrap flex-lg-row flex-column"
      actions={
        <React.Fragment>
          {!!attachmentId && (
            <Button color="primary" text size="sm" icon="download" onClick={() => window.open(fileLink)}>
              {resource.DownloadInvoice}
            </Button>
          )}
        </React.Fragment>
      }
    >
      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
        <ReactTable columns={columns} data={lines} showFooter responsive />
      </div>
    </Card>
 
      
    </div>
  )
}
